// extracted by mini-css-extract-plugin
module.exports = {"addressItem":"AddressItem_addressItem__3mQBk","addressText":"AddressItem_addressText__uM-t1","changeButton":"AddressItem_changeButton__3ba77"};